import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImmomioIconName } from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconWebComponent, TranslateModule],
})
export class InfoModalWebComponent {
  @Input() text: string;
  @Input() title: string;
  public activeModal = inject(NgbActiveModal);
  public immomioIconName = ImmomioIconName;
}
